import store from '@app/store';
import emitter from 'tiny-emitter/instance';
import { GalleryItem } from '@app/models';

const handleWebSocketMessage = (event: MessageEvent) => {
  const message = JSON.parse(event.data);
  if (message.type === 'entity_type_update') {
    store.commit('updateEntityType', message.data);
  }
  if (message.type === 'text_field_update') {
    emitter.emit('textFieldUpdated', message.data);
  }
  if (message.type === 'entity_gallery_item_created') {
    emitter.emit('entityGalleryItemCreated', new GalleryItem(message.data));
  }
  if (message.type === 'universe_gallery_item_created') {
    emitter.emit('universeGalleryItemCreated', new GalleryItem(message.data));
  }
};

export const openWebSocket = () => {
  let url = COW_API_URL;
  url = url.replace('https', 'wss');
  url = url.replace('http', 'ws');
  const socket = new WebSocket(`${url}/websocket`);

  socket.addEventListener('message', handleWebSocketMessage);

  return socket;
};

export const subscribeToUniverse = (websocket: WebSocket, universeId: string) => {
  websocket.send(JSON.stringify({
    type: 'subscribe',
    universe_id: universeId,
  }));
};
